import Box from '@mui/material/Box'
import Typography, { TypographyProps } from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { COLORS } from '@collections/colors'

interface TitleProps extends TypographyProps {
  isBlocked?: boolean
}

export const Section = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gridTemplateRows: 'max-content',
  width: '100%',
  padding: '20px',
  overflow: 'visible',
  position: 'relative',
  borderRadius: '10px',
  background: COLORS.white,
  border: `1px solid ${COLORS.gray87}`,

  '.MuiTypography-root': {
    gridColumn: '1 / 3'
  }
}))

export const TitleRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '12px',
  marginBottom: '20px',
  flexWrap: 'wrap'
}))

export const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isBlocked'
})<TitleProps>(({ theme, isBlocked }) => ({
  color: isBlocked ? COLORS.red : COLORS.green,
  fontWeight: '700',
  fontSize: '15px',
  lineHeight: '18px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0,
  '& span': {
    color: isBlocked ? COLORS.red : COLORS.green,
    fontSize: '12px',
    fontWeight: 600
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '13px'
  }
}))

export const StatusChips = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  alignItems: 'center'
}))

export const SubTitles = styled(Typography)(({ theme }) => ({
  fontWeight: '700',
  fontSize: '13px',
  lineHeight: '16px',

  [theme.breakpoints.down('md')]: {
    marginBottom: '7px'
  }
}))

export const StyledDoubleBox = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '50% 50%',
  gridColumn: '1 / 3',

  [theme.breakpoints.down('md')]: {
    display: 'flex',
    gap: '15px',
    flexDirection: 'column'
  }
}))

export const StyledAddressBox = styled(Box)(({ theme }) => ({
  gridColumn: '1 / 3',
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column'
  }
}))

export const StyledNoteBox = styled(Box)(() => ({
  gridColumn: '1 / 3'
}))

export const ActionsFooter = styled(Box)(() => ({
  gridColumn: '1 / 3',
  width: 'calc(100% + 40px)',
  marginLeft: '-20px',
  padding: '16px 20px 20px',
  borderTop: `1px solid ${COLORS.borderGray}`
}))

export const ClubToClubSetting = styled(Box)(() => ({
  background: '#f6f8f7',
  borderRadius: '8px',
  padding: '14px 16px',
  border: `1px solid ${COLORS.borderGray}`,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px'
}))

export const ClubToClubHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px'
}))

export const ClubToClubLabel = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '13px',
  lineHeight: '18px',
  color: COLORS.raisinBlack2
}))

export const ClubToClubHelperText = styled(Typography)(() => ({
  fontSize: '12px',
  lineHeight: '18px',
  color: COLORS.raisinBlack2,
  opacity: 0.78,
  whiteSpace: 'normal',
  wordBreak: 'break-word'
}))

export const ActionsGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '10px',
  marginTop: '14px',

  '.MuiButtonBase-root': {
    width: '100%',
    margin: 0,
    minHeight: '42px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '13px',
    borderRadius: '8px'
  },

  a: {
    display: 'block',
    minWidth: 0
  }
}))

export const ValueContainer = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}))

export const NoteValueContainer = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  word-break: break-word;
  -webkit-box-orient: vertical;
`

export const MainWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  marginBottom: '15px',

  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }
}))
